import React from 'react';
import AboutUs from '../../pageComponents/AboutUs';

const AboutUsPage = () => <AboutUs />;

export default AboutUsPage;
